import React from "react";
import styles from "./product_card.module.css";
import productImage from "../../images/product_1.png";



const ProductCard = ({ product }) => {

  return (
    <div className={styles.card}>
      <div className={styles.img_container}>
        <img className={styles.img} src={product.image1 ? product.image1 : productImage} alt={product.name} />
      </div>
      <p className={styles.name}>
        {product.name}
      </p>
    </div>
  );
}

export default ProductCard;
